<app-header *ngIf="!document_id"></app-header>
<div class="pdf-details" [ngClass]="{ wrapper: !document_id }" (click)="handleKeyboardEvent($event)">
  <app-poster-simmer *ngIf="shimmerStatus"></app-poster-simmer>

  <section *ngIf="!shimmerStatus && !access" class="bg-color" [ngClass]="{
      'day-bg-color': day,
      'sepia-bg-color': sepia,
      'night-bg-color': night
    }">
    <div [ngClass]="{ 'cus-playing': service.isShow === true }" *ngIf="!shimmerStatus">
      <div class="video-detail">

        <div class="pdf-banner player" *ngIf="!service.isShow">
          <img *ngIf="documentDetail.thumbnails.length === 0" src="assets/images/document-banner.jpg" alt="..." />
          <img *ngIf="documentDetail.thumbnails.length > 0" [src]="thumbnails" alt="..." />
          <!-- document-banner.jpg -->
          <!-- <img
            *ngIf="documentDetail.thumbnails.length > 0"
            [src]="[thumbnailhandleKeyboardEvents]"
            alt="..."
            /> -->

          <div *ngIf="
              (
                documentDetail?.view_days
                | viewdays: documentDetail?.current_date
              ).isLock
            " class="playerlock">
            <span class="mdi mdi-lock"></span>
          </div>

          <!-- <div *ngIf="!(documentDetail?.view_days | viewdays:documentDetail?.current_date)">
            <span class="read-text">Read Preview</span>
            <div class="playerlock" (click)="showPdf()">
              <span class="mdi mdi-file-pdf"></span>
            </div>
          </div> -->
        </div>
      </div>

      <div class="pdf-view" *ngIf="service.isShow">
        <div class="pdf-view-contents">
          <div class="row m-0 justify-content-center">
            <div class="col-12 col-sm-12 col-md-12 col-lg-8">
              <pdf-viewer (after-load-complete)="afterLoadComplete($event)" [src]="documentDetail.output_url"
                [show-borders]="showBorders" [show-all]="scroling" button [render-text]="true" [zoom-scale]="zoomScale"
                [(page)]="pageVariable" [zoom]="zoom">
              </pdf-viewer>
            </div>
          </div>
          <div class="control-panel">
            <div class="pdf-view-footer">
              <div class="">
                <p class="mb-0 mt-0" class="font-bold">
                  {{ pageVariable }}/{{ totalPages }}
                  {{ "DOCUMENT_DETAIL.PAGES" | translate }}
                </p>
              </div>
              <div class="text-right">
                <p class="mb-0 mt-0" class="font-bold">
                  {{ (pageVariable / totalPages) * 100 | number: "1.0-0" }}%
                  {{ "DOCUMENT_DETAIL.READ" | translate }}
                </p>
              </div>
            </div>
            <div class="slider-page">
              <div class="progress-page">
                <mat-slider [min]="1" [max]="totalPages" step="1" [value]="pageVariable" (change)="goToFinish($event)">
                </mat-slider>
              </div>
            </div>
            <div class="pdf-view-footer row">
              <div class="">
                <button mat-button class="btn ico-btn" [matMenuTriggerFor]="menu">
                  <span class="mdi mdi-cog"></span>
                </button>
                <mat-menu class="pdf-setting" #menu="matMenu">
                  <div (click)="$event.stopPropagation()" class="droup-box">
                    <div class="d-flex padding-li">
                      <button [ngClass]="{
                          active: day
                        }" class="theme day cursor-pointer" (click)="dayColor()" title="Day Theme"></button>
                      <button [ngClass]="{
                          active: sepia
                        }" class="theme sepia cursor-pointer" (click)="sepiaColor()" title="Sepia Theme"></button>
                      <button [ngClass]="{
                          active: night
                        }" class="theme night cursor-pointer" (click)="nightColor()" title="Night Theme"></button>
                    </div>
                    <hr />
                    <div class="d-flex justify-content-center align-items-center padding-li">
                      <button (click)="zoomOut()" class="btn p-0 btn-pl">
                        <span class="mdi mdi-minus-circle-outline"> </span>
                      </button>
                      <span class="icon-cap-small icon-size"></span>
                      <button (click)="zoomIn()" class="btn p-0 btn-pl">
                        <span class="mdi mdi-plus-circle-outline"> </span>
                      </button>
                    </div>
                    <hr />
                    <div class="padding-li">
                      <p class="font-bold">
                        {{ "DOCUMENT_DETAIL.SCROLL" | translate }}
                      </p>
                      <div class="d-flex">
                        <div [ngClass]="{
                            'active-scroling1': !scroling
                          }" class="mr-3 scroll-div cursor-pointer" (click)="scroling = false">
                          <span class="icon-skroll-left icon-size"></span>
                        </div>
                        <div [ngClass]="{
                            'active-scroling2': scroling
                          }" class="scroll-div cursor-pointer" (click)="scroling = true">
                          <span class="icon-skroll-bottom icon-size"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-menu>
              </div>
              <div class="next-prev-btn d-flex align-items-center justify-content-center">
                <button (click)="
                    pageVariable > 1 && (pageVariable = pageVariable - 1)
                  " class="line-height btn ico-btn p-0 mr-3">
                  <div class="mdi mdi-chevron-left"></div>
                </button>
                <span *ngIf="playStatus" class="mdi mdi-play" (click)="play()">
                </span>
                <span *ngIf="!playStatus" class="mdi mdi-pause" (click)="pause()"></span>
                <button class="btn ico-btn p-0 ml-3 line-height" (click)="pageVariable = pageVariable + 1">
                  <div class="mdi mdi-chevron-right"></div>
                </button>
              </div>

              <div class="search-box search-icon" [ngClass]="{ 'search-icon': showSearch }">
                <div class="mr-2">
                  <div class="input-group-prepend">
                    <button class="btn ico-btn" (click)="onClick()">
                      <span class="mdi mdi-magnify"></span>
                    </button>
                  </div>
                  <input class="form-control" #queryInp id="pdfQueryInput" type="text" placeholder="Search..."
                    [value]="pdfQuery" (input)="searchQueryChanged($event.target.value)"
                    (keyup.enter)="searchQueryChanged(queryInp.value)" />
                  <a href="javascript:void(0)" class="close-input" (click)="remove()">
                    <span class="icon-close"></span>
                  </a>
                </div>
                <button *ngIf="!expandStatus" class="btn ico-btn" (click)="openFullscreen()">
                  <span class="mdi mdi-arrow-expand-all"></span>
                </button>
                <button *ngIf="expandStatus" class="btn ico-btn" (click)="closeFullscreen()">
                  <span class="mdi mdi-arrow-collapse-all"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="video-content" *ngIf="documentDetail && !document_id">
        <div class="container">
          <div class="banner-content-box">
            <app-video-info [videoDetail]="documentDetail" [url]="encodeUrl" [public_id]="public_id">
            </app-video-info>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="!shimmerStatus && access">
    <div class="video-not-support">
      <img [src]="appConstant.BrowserNotSupported" />
      <h4>
        {{ accessMessage }}
      </h4>
    </div>
  </section>
</div>
<app-footer *ngIf="!document_id"></app-footer>